import { Badge, BadgeProps } from 'antd';

interface DotTagProps {
  isActive: boolean;
}

export default function UserStatusTag({ isActive }: DotTagProps & BadgeProps) {
  if (isActive) return <Badge status="success" />;
  return <Badge status="error" />;
}
